import { handleActions } from "redux-actions";
import {
  getLandingList,
  getStopsList,
  setLandingList,
  setStopsList, updateLandingList
} from "../actions/landingListAction";

const initState = {
  persons: {
    data: []
  },
  tableLoading: false,
  errorMessage: null,
  updated: false,
  stops: null
};

const landingListReducer = handleActions(
  {
    [getLandingList]: state => {
      return { ...state, tableLoading: true };
    },
    [setLandingList]: (state, action) => {
      return {
        ...state,
        persons: action.payload,
        tableLoading: false,
        updated: false
      };
    },
    [getStopsList]: state => {
      return state;
    },
    [setStopsList]: (state, action) => {
      return {
        ...state,
        stops: action.payload
      };
    },
    [updateLandingList]: (state, action) => {
      return state;
    }
  },
  initState
);

export default landingListReducer;
